// Module
var code = "<main ui-view></main>";
// Exports
module.exports = code;